<template>
  <footer 
    class="site-footer custom-fixed-footer d-flex align-items-center"
    :style="{
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.12)',
      backgroundColor: themeStore.isDark ? 'rgba(15, 15, 26, 0.75)' : 'rgba(255, 255, 255, 0.75)',
      color: themeStore.isDark ? '#fff' : '#212529',
      borderTop: themeStore.isDark ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.06)'
    }"
  >
    <div class="footer-inner-container d-flex justify-content-between align-items-center w-100 position-relative">
      
      <!-- DESKTOP ESQUERDA: Termos & Privacidade -->
      <div class="d-none d-lg-flex align-items-center gap-3 footer-left-group" style="font-size: 0.8rem;">
        <router-link 
          to="/termos" 
          class="text-decoration-none transition-color hover-primary" 
          :style="{ color: themeStore.isDark ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.65)' }"
        >
          Termos
        </router-link>
        <router-link 
          to="/privacidade" 
          class="text-decoration-none transition-color hover-primary" 
          :style="{ color: themeStore.isDark ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.65)' }"
        >
          Privacidade
        </router-link>
      </div>

      <!-- MOBILE ESQUERDA: Logo da Marca -->
      <div class="d-flex d-lg-none align-items-center gap-2">
        <router-link to="/" class="text-decoration-none transition-color hover-primary" :style="{ color: themeStore.isDark ? '#fff' : '#212529' }">
          <span class="fw-bold fs-6 font-cinzel">Bar Experts</span>
        </router-link>
      </div>

      <!-- DESKTOP CENTRO: caos bar experts since 2024 (Centralizado matematicamente) -->
      <div class="d-none d-lg-flex align-items-center gap-2 footer-center-group">
        <span 
          class="font-monospace footer-copyright-text" 
          :style="{ color: themeStore.isDark ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)' }"
        >
          caos bar experts since 2024
        </span>

        <!-- FERRAMENTAS DE EDIÇÃO VISUAL CURSOS (N4/N5 AUDITOR) -->
        <div v-if="auth.isAuditor && isCourseDetailPage" class="d-flex align-items-center gap-1 ms-2">
          <span class="badge me-1" :class="coursesStore.isEditMode ? 'bg-secondary' : 'bg-secondary'" style="font-size: 0.65rem;">
            {{ coursesStore.isEditMode ? 'EDIÇÃO' : 'AUDITOR' }}
          </span>

          <template v-if="coursesStore.isEditMode">
            <input 
              type="text" 
              class="form-control form-control-sm bg-black text-white border-secondary font-monospace py-0 px-1 rounded-2" 
              v-model="coursesStore.activeEditForm.slug" 
              placeholder="slug"
              style="width: 100px; font-size: 0.7rem;" 
            />
            <small :class="isSlugValid ? 'text-body-emphasis' : 'text-danger'" class="fw-bold me-1" style="font-size: 0.65rem;">
              <i :class="isSlugValid ? 'bi-check-circle-fill' : 'bi-x-circle-fill'"></i>
            </small>

            <button class="btn btn-sm btn-outline-secondary py-0 px-1 rounded-2" style="font-size: 0.7rem;" @click="coursesStore.triggerSponsorModal" title="Gerenciar Marcas Patrocinadoras">
              <i class="bi-images"></i>
            </button>

            <button class="btn btn-sm btn-dark py-0 px-2 fw-bold rounded-2" style="font-size: 0.7rem;" @click="coursesStore.triggerSavePage">
              <i class="bi-check-lg me-1"></i> Salvar
            </button>

            <button class="btn btn-sm btn-outline-light py-0 px-1 rounded-2" style="font-size: 0.7rem;" @click="coursesStore.isEditMode = false">
              <i class="bi-x-lg"></i>
            </button>
          </template>

          <template v-else>
            <button class="btn btn-sm btn-dark py-0 px-2 fw-bold rounded-2 text-dark" style="font-size: 0.7rem;" @click="coursesStore.isEditMode = true">
              <i class="bi-pencil-square me-1"></i> Editar Página
            </button>
          </template>
        </div>
      </div>

      <!-- DESKTOP DIREITA: Tema Claro/Escuro à esquerda do Versionamento -->
      <div class="d-none d-lg-flex align-items-center gap-2 footer-right-group">
        <button 
          @click="themeStore.toggleTheme()" 
          class="btn btn-sm btn-link p-0 text-decoration-none transition-color hover-primary d-flex align-items-center justify-content-center me-1" 
          :title="themeStore.isDark ? 'Modo Claro' : 'Modo Escuro'"
          :aria-label="themeStore.isDark ? 'Mudar para Modo Claro' : 'Mudar para Modo Escuro'"
        >
          <i :class="themeStore.isDark ? 'bi-sun-fill text-white fs-5' : 'bi-moon-stars fs-6'" :style="{ color: themeStore.isDark ? '#ffffff' : '#212529' }"></i>
        </button>
        <span class="badge bg-secondary" style="font-size: 0.68rem; font-weight: 500;">v2.00.51</span>
      </div>

      <!-- MOBILE DIREITA: Theme Toggle + Versão inline -->
      <div class="d-flex d-lg-none align-items-center gap-2">
        <button 
          @click="themeStore.toggleTheme()" 
          class="btn btn-sm btn-link p-1 text-decoration-none ms-1 transition-color hover-primary d-flex align-items-center justify-content-center" 
          :title="themeStore.isDark ? 'Modo Claro' : 'Modo Escuro'" 
          :aria-label="themeStore.isDark ? 'Mudar para Modo Claro' : 'Mudar para Modo Escuro'"
        >
          <i :class="themeStore.isDark ? 'bi-sun-fill text-white fs-5' : 'bi-moon-stars fs-6'" :style="{ color: themeStore.isDark ? '#ffffff' : '#212529' }"></i>
        </button>
        <span class="badge bg-secondary" style="font-size: 0.6rem; margin-top: 1px;">v2.00.51</span>
      </div>

    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useThemeStore } from '../stores/theme'
import { useAuthStore } from '../stores/auth'
import { useCoursesStore } from '../stores/coursesStore'
import { useNotificationStore } from '../stores/notificationStore'

const route = useRoute()
const themeStore = useThemeStore()
const auth = useAuthStore()
const coursesStore = useCoursesStore()
const notificationStore = useNotificationStore()

const isCourseDetailPage = computed(() => {
  return route.path.startsWith('/cursos/') && route.params.slug
})

const isSlugValid = computed(() => {
  if (!coursesStore.activeEditForm.slug) return false
  return coursesStore.isSlugAvailable(coursesStore.activeEditForm.slug, route.params.slug)
})
</script>

<style scoped>
.custom-fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 38px;
  z-index: 1040;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  padding: 0;
}

.footer-inner-container {
  padding: 0 1.75rem;
  height: 100%;
}

.footer-center-group {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  pointer-events: auto;
}

.footer-copyright-text {
  font-size: 0.75rem;
  letter-spacing: 0.2px;
}

/* Breakpoint S11 - Ultrawide (min-width: 2000px): Margem nas bordas extremas */
@media (min-width: 2000px) {
  .footer-inner-container {
    max-width: 1800px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 4rem;
    padding-right: 4rem;
  }
}

/* Breakpoint S11 - Celular / Tablets (< 992px / 1080px): Fixado no topo no mobile */
@media (max-width: 991.98px) {
  .custom-fixed-footer {
    height: auto;
    bottom: auto;
    top: 0;
    border-top: none !important;
    border-bottom: 1px solid rgba(128, 128, 128, 0.15) !important;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    padding: 0.35rem 0;
  }

  .footer-inner-container {
    padding: 0 1rem;
  }
}

.transition-color {
  transition: color 0.2s ease;
}
.hover-primary:hover {
  color: var(--bs-primary) !important;
}
</style>
